const philosophies = [
  {
    number: '01',
    title: '行动先于完美',
    desc: '等待完美的时机、完美的方案、完美的状态，你永远等不到。先做起来，在行动中迭代，在迭代中靠近完美。',
    icon: 'ri-rocket-line',
  },
  {
    number: '02',
    title: '5 秒打破犹豫',
    desc: '当你产生行动冲动的瞬间，倒数 5-4-3-2-1 然后立刻开始。不给大脑编造借口的5秒钟窗口。',
    icon: 'ri-timer-flash-line',
  },
  {
    number: '03',
    title: '微小就是力量',
    desc: '每天只做一个俯卧撑、只写 50 个字。微不足道的行动积累起来，会产生惊人的复利效应。',
    icon: 'ri-seedling-line',
  },
  {
    number: '04',
    title: '行动创造动力',
    desc: '不要等有动力了才行动。恰恰相反：先行动，动力自然会来。行动本身是最好的激励。',
    icon: 'ri-fire-line',
  },
];

export default function PhilosophySection() {
  return (
    <section className="py-16 md:py-24 px-4 md:px-6 bg-background-50" aria-labelledby="philosophy-title">
      <div className="max-w-6xl mx-auto">
        <div className="text-center mb-14">
          <p className="text-xs md:text-sm text-primary-500 font-semibold tracking-[0.2em] uppercase mb-3">
            核心理念
          </p>
          <h2 id="philosophy-title" className="text-2xl md:text-4xl font-heading font-bold text-foreground-950">
            行动力哲学四大法则
          </h2>
          <p className="mt-4 text-foreground-600 text-sm md:text-base max-w-xl mx-auto">
            「就去干」不是鲁莽，是一套经过验证的行动方法论。这四条法则，是无数行动者的智慧结晶。
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5 md:gap-6">
          {philosophies.map((item, index) => (
            <div
              key={item.number}
              className="group relative bg-background-50 p-6 md:p-8 rounded-lg border border-background-200/80 hover:border-primary-200 transition-all duration-300"
            >
              <div className="w-10 h-10 md:w-12 md:h-12 flex items-center justify-center rounded-lg bg-primary-100 text-primary-600 mb-5 group-hover:bg-primary-500 group-hover:text-background-50 transition-all duration-300">
                <i className={`${item.icon} text-lg md:text-xl`}></i>
              </div>
              <span className="absolute top-4 right-4 text-4xl md:text-5xl font-heading font-bold text-background-200 group-hover:text-primary-100 transition-colors duration-300">
                {item.number}
              </span>
              <h3 className="text-base md:text-lg font-heading font-bold text-foreground-950 mb-3">
                {item.title}
              </h3>
              <p className="text-sm text-foreground-600 leading-relaxed">
                {item.desc}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}